import type { ReactNode } from 'react';

interface TerminalProps {
  children: ReactNode;
  /** The title bar with three dots (docs/brand.md → Terminal and request log). Off for one-line prompts. */
  chrome?: boolean;
  className?: string;
}

/**
 * A marketing terminal: `neutral` in both themes, pinned to mockd-dark because mockd-light's
 * semantic colours are too dark to read on `neutral`.
 */
export function Terminal({ children, chrome = false, className = '' }: TerminalProps) {
  return (
    <div
      data-theme="mockd-dark"
      className={`rounded-box overflow-hidden bg-neutral text-neutral-content font-mono text-sm ${className}`}
    >
      {chrome && (
        <div aria-hidden="true" className="flex gap-1.5 px-3 py-2 bg-neutral-content/5">
          <span className="size-2.5 rounded-full bg-neutral-content/20" />
          <span className="size-2.5 rounded-full bg-neutral-content/20" />
          <span className="size-2.5 rounded-full bg-neutral-content/20" />
        </div>
      )}
      <div className="px-4 py-3 overflow-x-auto leading-relaxed">{children}</div>
    </div>
  );
}

/** The `$` prompt, in primary. */
export function Prompt() {
  return <span aria-hidden="true" className="text-primary select-none">$ </span>;
}
